import React, {useEffect, useState, useRef} from 'react';
import Axios from 'axios';
import { Alert } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
import '../App.css';
import Pagination from '../components/global/Paginator'
import {exportToExcel} from "../utils/reports/exportToExcel";
import {formatDate} from "../utils/dates";


function Grillaboticket (props){
    const fileInputRef = useRef();
    const searchInput = useRef(null);
    const [show, setShow] = useState(false);
    const [datos, setDatos] = useState([]);
    const [datosExport, setDatosExport] = useState([]);
    const [datosBackup, setDatosBackup] = useState([])
    const [idcasino, setIdCasino] = useState()
    const [nombrecasino, setNombreCasino] = useState()
    const [direccioncasino, setDireccionCasino] = useState()
    const [valorticketcasino, setValorTicketCasino] = useState()
    const [empresacasino, setEmpresaCasino] = useState()
    const [rut, setRut] = useState()
    const [rut2, setRut2] = useState('')
    const [fecha, setFecha] = useState('')
    const [visible, setVisible] = useState('seccionNoVisible')
    const [beneficiariobyuser, setBeneficiariobyuser] = useState([])
    const [selectBeneficiarios, setSelectBeneficiarios] = useState()
    const [beneficiario, setBeneficiario] = useState()
    const [ticketid, setTicketId] = useState()
    const [user, setUser] = useState()
    const [tituloAlert, setTituloAlert] = useState('')
    const [textoAlert, setTextoAlert] = useState('')
    const [claseAlert, setClaseAlert] = useState('')
    const [alert, setAlert] = useState(false);
    
    const [tituloAlert1, setTituloAlert1] = useState('')
    const [textoAlert1, setTextoAlert1] = useState('')
    const [claseAlert1, setClaseAlert1] = useState('')    
    const [alert1, setAlert1] = useState(false);

    const [tituloAlert3, setTituloAlert3] = useState('')
    const [textoAlert3, setTextoAlert3] = useState('')
    const [claseAlert3, setClaseAlert3] = useState('')    
    const [alert3, setAlert3] = useState(false);

    const [fechainicio, setFechaInicio] = useState('')
    const [fechafinal, setFechaFinal] = useState('')
    const [file, setFile] = useState('');
    const [fileName, setFileName] = useState("");
    const [barcode, setBarCode] = useState('')
    const [barcoderest, setBarcoderest] = useState('')
    const [pageNumber, setPageNumber] = useState('')
    const [pageSize, setPageSize] = useState(3);
    const [totalPages, setTotalPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);   
    const [isUploading, setIsUploading] = useState(false);

    let statuscall = '' 
    const dataList = Array.isArray(datos) && datos.length > 0
    ? datos.map((item, i) => (
    <tr key={i} class="divide-y divide-gray-100 bg-white">
        <td class="px-6 py-4 whitespace-nowrap text-sm">{item.rutcliente}</td>
        <td class="px-6 py-4 whitespace-nowrap text-sm">{item.nombre + " " +item.apellido}</td>
        <td class="px-6 py-4 whitespace-nowrap text-sm">{item.rutbeneficiario}</td>
        <td class="px-6 py-4 whitespace-nowrap text-sm">$ {item.valor}</td>
        <td class="px-6 py-4 whitespace-nowrap text-sm">{item.estadopago}</td>
        <td class="px-6 py-4 whitespace-nowrap text-sm">{item.estadoconsumo}</td>
        <td class="px-6 py-4 whitespace-nowrap text-sm">{item.fecha_pago}</td>
        <td class="px-6 py-4 whitespace-nowrap text-sm">{item.fecha_consumo}</td>
    </tr>
    )):(
      // opcional: fila vacía o mensaje cuando no hay datos
      <tr>
        <td className="px-6 py-4 text-sm text-gray-500" colSpan={7}>
          Sin resultados
        </td>
      </tr>
    );


    const handleExport = () => {
        
        let idcasino = window.localStorage.getItem('MY_APP_STATE_PROF_CASINO_ID').replace('"', '')
        Axios.get(process.env.REACT_APP_URLTICKETLISTAREXCEL, {
            params: {
                casino: idcasino.replace('"', ''),
                fecha_inicio: fechainicio, 
                fecha_fin: fechafinal
            }, 
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {
            setDatosExport(response.data.tickets)
        }).catch(error => {
            return error     
        });

        const formattedData = datosExport.map((tickets) => ({
            Rut_apoderado: tickets.rutcliente,
            Mail_apoderado: tickets.mail,
            Nombre_apoderado: tickets.nombre,
            Apellido_apoderado: tickets.apellido,
            Rut_beneficiario: tickets.rutbeneficiario,
            Valor_ticket: tickets.valor,
            Estado_pago: tickets.estadopago,
            Estado_consumo: tickets.estadoconsumo,
            Fecha_Pago: tickets.fecha_pago,
            Fecha_Consumo: tickets.fecha_consumo,
            Nombre_Casino: tickets.nombrecasino,
            Ticket_id: tickets.ticket_id
        }))
        exportToExcel(formattedData, `ReporteTickets_${formatDate()}.xlsx`, "Tickets");
    };    

    const handleKeyDown = (event) => {
        if (event.keyCode === 13)
        {
            setBarCode(event.value)
        }
    }

    const consumirTicket = (e) => {
        if(barcoderest != '')
        {
            let idtrim = barcoderest.trim()
            let id = idtrim.substring(16, idtrim.length)
            Axios.get(process.env.REACT_APP_URLTICKETSCANN, {
                params: {
                    id: id 
                }, 
                headers: {
                    'Access-Control-Allow-Origin' : '*',
                    'Access-Control-Allow-Methods': 'GET, POST',
                    'Access-Control-Allow-Headers': 'Content-Type'
                }
            }).then((response) => {
    
                if(response.data.MessageCode === '0')
                {
                    setTituloAlert3('Consumo por scanner')
                    setTextoAlert3('Ticket Consumido')
                    setClaseAlert3('success')
                    setBarCode('')
                    setAlert3(true)
                    searchInput.current.focus()
                    setTimeout(() => {    
                        setAlert3(false)
                    }, 3000)
                }
                else
                {
                    setTituloAlert3('Consumo por scanner')
                    setTextoAlert3('Ticket Ya Consumido o no Existente')
                    setClaseAlert3('warning')
                    setBarCode('')
                    setAlert3(true)
                    searchInput.current.focus()
                    setTimeout(() => {    
                        setAlert3(false)
                    }, 3000)
                }
            }).catch(error => {
                return error     
            });
        }
        else
        {
            setTituloAlert3('Consumo por scanner')
            setTextoAlert3('Debe scannear el codigo primero')
            setClaseAlert3('warning')
            setAlert3(true)
            setTimeout(() => {    
                setAlert3(false)
            }, 3000)
        }

    }

    const handleBeneficiario = async (e) =>{
        setBeneficiario(e.target.value)
    }

    const handleRut = async (e) =>{
        setRut(e.target.value)
    }    

    const handleRut2 = async (e) =>{
        // Despejar Puntos
        let valor = e.target.value.replace('.','');
        // Despejar Guión
        valor = valor.replace('-','');
                
        // Aislar Cuerpo y Dígito Verificador
        let cuerpo = valor.slice(0,-1);
        let dv = valor.slice(-1).toUpperCase();
                
        // Formatear RUN
        setRut2(cuerpo + '-'+ dv)
        setVisible('seccionNoVisible')
    }

    const handleFecha = async (e) =>{
        setFecha(e.target.value)
        setVisible('seccionNoVisible')
    } 
    
    const handleBarcode = async (e) =>{
        setBarcoderest(e.target.value)
    }

    const putCasino = async () =>{
        let urlput = process.env.REACT_APP_URLPUTCASINO+idcasino.toString()+'/update'
        let authcode = window.localStorage.getItem('MY_APP_STATE_AUTHCODE').replace('"', '')
        const data = {   
            direccion: direccioncasino,
            value_ticket: valorticketcasino,
        };

        const casinoPut = await Axios.put(urlput, data, {
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
        }}).then(res => statuscall = res).catch(err => statuscall = err.response);
            
        if(statuscall.status == 200)
        {   
            handleGrillaCasino()
            handleClose()
        }
    }

    const handleGrillaCasino = async () =>{
        Axios.get(process.env.REACT_APP_URLCASINO, {
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {
            setDatos(response.data)
            setDatosBackup(response.data)
        }).catch(error => {
            return error     
        });
    }

    const createConsumoManual = async () =>{
        if(beneficiario != '')
        {
            if(fecha != "")
            {
                const data = {
                    tickets:[{
                        user: user,
                        beneficiario: beneficiario,
                        ticket_id: ticketid,
                        fechaconsumo: fecha 
                        }
                    ]
                }
                const res = await Axios.post(process.env.REACT_APP_URLCREATECONSUMO, data,{
                    headers: {
                        'Access-Control-Allow-Origin' : '*',
                        'Access-Control-Allow-Methods': 'GET, POST',
                        'Access-Control-Allow-Headers': 'Content-Type'
                }}).then(res => statuscall = res).catch(err => statuscall = err.response);
                            
                if (statuscall.data.MessageCode == "0")
                {
                    GetTicket()

                    setTituloAlert('Consumo de tickets')
                    setTextoAlert('Consumo creado')
                    setClaseAlert('success')
                    setAlert(true)
                    setTimeout(() => {    
                        setAlert(false)
                        handleClose()
                    }, 3000)
                }
            }
            else
            {
                setTituloAlert('Consumo de tickets')
                setTextoAlert('Debe seleccionar una fecha')
                setClaseAlert('warning')
                setAlert(true)
                setTimeout(() => {    
                    setAlert(false)
                }, 3000)
            }


        }
        else
        {
            setTituloAlert('Consumo de tickets')
            setTextoAlert('Debe seleccionar un beneficiario')
            setClaseAlert('warning')
            setAlert(true)
            setTimeout(() => {    
                setAlert(false)
            }, 3000)
            
        }
    }

    const handlePageSize = (e) => {
        setPageSize(e.target.value)
    }

    const listBeneficiarios = beneficiariobyuser.map((item, i) =>
        <option key={i} value={item.id}>{item.primer_nombre} {item.primer_apellido}</option>
    )

    const GetTicket = () =>
    {
        const date = new Date();

        // Formateamos la fecha en formato yyyy-mm-dd
        const formattedDate = date.toISOString().split('T')[0];

        let idcasino = window.localStorage.getItem('MY_APP_STATE_PROF_CASINO_ID').replace('"', '')
        Axios.get(process.env.REACT_APP_URLTICKETLISTAR, {
            params: {
                page: pageNumber || 1,
                pageSize: pageSize || 10,
                casino: idcasino.replace('"', ''),
                fecha_inicio: fechainicio || formattedDate,
                fecha_fin: fechafinal || formattedDate
            }, 
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {
            setDatos(response.data.tickets)
            setDatosBackup(response.data.tickets)

            setCurrentPage(response.data.tickets_metadata.currentPage)
            setPageNumber(response.data.tickets_metadata.currentPage)
            setTotalPages(response.data.tickets_metadata.totalPages)
        }).catch(error => {
            return error     
        });
    }


    useEffect(() => {
        GetTicket()
        window.addEventListener('keydown', handleKeyDown);
        // cleanup this component
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        }        
    }, [pageNumber]);

    const clickTicket= (item) =>{
        //Setea usuario
        setUser(item.mail)
        setRut(item.rutcliente)

        //Busca beneficiarios por usuario
        Axios.get(process.env.REACT_APP_URLBENEFICIARIOSBYUSERS, {
            params: {
                mail:item.mail 
            }, 
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {
            setBeneficiariobyuser(response.data.beneficiarios)
            //Setea beneficiario
            //setSelectBeneficiarios(listBeneficiarios)
        }).catch(error => {
            return error     
        });

        //Setea id ticket
        setTicketId(item.ticket_id)

        handleShow()
    }

    const handleClose = () => {
        setRut('')
        setBeneficiario('')
        setFecha('')
        setShow(false)
    }
    const handleShow = () => setShow(true)

    const handleChangeList= (e) => {
        let text = e.target.value;
        const setBusqueda = e.target.value;
        const data = datosBackup
        const newData = data.filter(
            function(item){
                const itemDataRutcliente = item.rutcliente
                const itemDataRutBeneficiario = item.rutbeneficiario
                const itemDatanombre =  (item.nombre ?? '').toUpperCase(); 
                const itemDataapellido = (item.apellido ?? '').toUpperCase()
                const itemDataestadopago = (item.estadopago ?? '').toUpperCase()
                const itemDataestadoconsumo = (item.estadoconsumo ?? '').toUpperCase()
                const itemDatavalor = item.valor
                const campo = itemDatanombre +" "+ itemDataapellido +" "+ itemDataRutcliente+" "+itemDataRutBeneficiario +" "+itemDataestadopago+" "+itemDataestadoconsumo+" "+itemDatavalor
                const textData = text.toUpperCase()
                return campo.indexOf(textData) > -1        
            }
        )
        setDatos(newData)
    }

    const handleFechaInicio = (e) => {
        setFechaInicio(e.target.value)
    }

    const handleFechaFinal = (e) => {
        setFechaFinal(e.target.value)
    }

    const saveFile = (e) => {
        setFile(e.target.files[0]);
        setFileName(e.target.files[0].name);
    }
 
    const uploadFile = async (e) => {
        if (!file) {
            setTituloAlert1('Consumo masivo de tickets')
            setTextoAlert1('Debe seleccionar un archivo')
            setClaseAlert1('warning')
            setAlert1(true)
            setTimeout(() => setAlert1(false), 3000)
            return;
        }
    
        setIsUploading(true);
    
        let idcasinoappstr = window.localStorage.getItem('MY_APP_STATE_PROF_CASINO_ID').replace('"', '');
        const formData = new FormData();
        formData.append("file", file);
        formData.append("fileName", fileName);
        formData.append("casino_id", idcasinoappstr);
    
        try {
            const res = await Axios.post(
                process.env.REACT_APP_URLTICKETPROCESOMASIVO,
                formData
            );
    
            fileInputRef.current.value = null;
            setFile('');
            setFileName('');
    
            if (res.data.MessageCode === "0") {
                setTituloAlert1('Consumo masivo de tickets');
                setTextoAlert1('Archivo Cargado y Procesado Correctamente');
                setClaseAlert1('success');
            } else {
                setTituloAlert1('Error en carga');
                setTextoAlert1('No se pudo procesar el archivo');
                setClaseAlert1('warning');
            }
    
        } catch (ex) {
            console.log(ex);
            setTituloAlert1('Error en conexión');
            setTextoAlert1('No se pudo contactar al servidor');
            setClaseAlert1('danger');
        }
    
        setAlert1(true);
        setTimeout(() => setAlert1(false), 3000);
        setIsUploading(false); 
    };


    return(
    <div className='w-full'>
        
        {/* Zona 1 - Filtros */}
        <div className="bg-white shadow-lg p-6  mx-4 mb-2">
            {/* Zona 1 - Header con Título y Filtros */}
            <div class="flex flex-col md:flex-row md:items-center md:justify-between mb-6 gap-4">
            <h1 class="text-2xl font-bold">Gestion Tickets</h1>
            
            <div class="flex flex-wrap gap-4">
                
                {/* Campo Fecha Inicio */}
                <div className="flex flex-col">
                    <input
                    placeholder='Fecha Inicio'
                    value={fechainicio} 
                    onChange={handleFechaInicio} 
                    type="date" 
                    id="fechaInicio" 
                    class="border border-gray-300 rounded-lg pl-10 pr-3 py-2 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-500" 
                    />
                </div>

                {/* Campo Fecha Fin */}
                <div className="flex flex-col">
                    <input
                    placeholder='Fecha Fin'
                    value={fechafinal} 
                    onChange={handleFechaFinal}  
                    type="date" 
                    id="fechaFin" 
                    class="border border-gray-300 rounded-lg pl-10 pr-3 py-2 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-500" 
                    />
                </div>

                {/* Campo Selección Número de Páginas */}
                <div className="flex flex-col">
                    <input 
                    placeholder='Registros por página'
                    type="number" 
                    id="numeroPaginas"
                    value={pageSize}
                    onChange={handlePageSize} 
                    min="1" 
                    step="1" 
                    defaultValue="1" 
                    class="border border-gray-300 rounded-lg pl-10 pr-3 py-2 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-500" 
                    />
                </div>

                {/*Buscador*/}
                <div class="relative">
                <input type="text" 
                    placeholder="Buscar en grilla" 
                    class="border border-gray-300 rounded-lg pl-10 pr-3 py-2 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    id="Buscar en grilla"
                    onChange={handleChangeList} />
                <div class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-4.35-4.35m1.4-5.4a7 7 0 11-14 0 7 7 0 0114 0z"/>
                    </svg>
                </div>
                </div>

                {/* Botón generar reporte */}
                <button
                    onClick={GetTicket}
                    className="flex items-center gap-2 bg-sky-600 hover:bg-sky-700 text-white text-sm font-medium px-4 py-2 rounded-lg shadow"
                    >
                    <svg
                        className="w-4 h-4 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 12h6m-6 4h6m2 4H7a2 2 0 01-2-2V6a2 2 0 012-2h7l5 5v11a2 2 0 01-2 2z"
                        />
                    </svg>
                    <span>Generar Reporte</span>
                </button>

                {/*Botón Exportar a Excel*/}
                <button onClick={handleExport} class="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white text-sm font-medium px-4 py-2 rounded-lg shadow">
                <svg class="w-4 h-4 fill-current text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                    <path d="M384 121.9V128H272V0H128C92.7 0 64 28.7 64 64v384c0 35.3 28.7 64 64 64h192c35.3 0 64-28.7 64-64V160h64v-38.1c0-13.1-10.6-23.9-23.7-23.9H384zM299.1 272l-42.1 48 42.1 48H258l-26.5-31.1L205 368h-40.5l42.1-48-42.1-48H205l26.5 31.1L258 272h41.1z"/>
                </svg>
                <span>Export</span>
                <svg class="w-4 h-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5m0 0l5-5m-5 5V4" />
                </svg>
                </button>

            </div>
            </div>
        </div>

        {/* Zona 2 */}
        <div className="bg-white shadow-lg p-4 mx-4 mb-2">
            {/* Controles de Búsqueda y Exportar */}
            <div className="overflow-y-auto h-[600px] p-4">
                {/* Contenedor para los detalles de los tickets */}
                <div className="space-y-6">
                    <div class="bg-white shadow rounded-2xl overflow-hidden">
                        <div class="max-h-96 overflow-y-auto">
                            <table class="min-w-full table-auto">
                            <thead class="bg-gray-50 sticky top-0 z-10">
                                <tr>
                                    <th class="px-6 py-4 text-left text-sm font-semibold text-gray-600 bg-gray-50">Rut Cliente</th>
                                    <th class="px-6 py-4 text-left text-sm font-semibold text-gray-600 bg-gray-50">Nombre Cliente</th>
                                    <th class="px-6 py-4 text-left text-sm font-semibold text-gray-600 bg-gray-50">Rut Alumno</th>
                                    <th class="px-6 py-4 text-left text-sm font-semibold text-gray-600 bg-gray-50">Valor Ticket</th>
                                    <th class="px-6 py-4 text-left text-sm font-semibold text-gray-600 bg-gray-50">Est. Pago</th>
                                    <th class="px-6 py-4 text-left text-sm font-semibold text-gray-600 bg-gray-50">Est. Consumo</th>
                                    <th class="px-6 py-4 text-left text-sm font-semibold text-gray-600 bg-gray-50">Fecha Pago</th>
                                    <th class="px-6 py-4 text-left text-sm font-semibold text-gray-600 bg-gray-50">Fecha Consumo</th>
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-100 bg-white">
                                {dataList}
                            </tbody>
                            </table>
                        </div>

                        {/*Paginación*/} 
                        <div class="flex items-center justify-between mt-6">
                            <div class="inline-flex items-center space-x-2">
                            <Pagination currentPage={pageNumber} totalPages={totalPages} onPageChange={setPageNumber}/>            
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div className="bg-white shadow-lg p-6  mx-4 mb-2">
            <h2 className="text-xl font-semibold mb-4">Subir Archivos</h2>
            <p className="mb-4">Seleccione un archivo y haga clic en procesar.</p>
            {alert1
                ?<Alert variant={claseAlert1} onClose={() => setAlert1(false)} dismissible fade show>
                    <Alert.Heading>{tituloAlert1}</Alert.Heading>
                        <p>
                            {textoAlert1}
                         </p>
                </Alert>
                :''
            }
            {/* Contenedor de los controles */}
            <div className="flex flex-col sm:flex-row gap-4">
                {/* Input File */}
                <div className="flex-1">
                <input
                    type="file"
                    ref={fileInputRef} onChange={saveFile}
                    className="block w-full text-sm text-gray-500
                    file:py-2 file:px-4 file:rounded-lg file:border-0
                    file:text-sm file:font-semibold file:bg-indigo-600 file:text-white 
                    hover:file:bg-indigo-700 focus:outline-none"
                />
                </div>

                {/* Botón Procesar con icono */}
                <div>
                <button
                    onClick={uploadFile}
                    disabled={isUploading} // 👈 Esto bloquea el botón mientras procesa
                    className={`flex items-center px-4 py-2 text-white rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-indigo-500 ${
                        isUploading ? 'bg-gray-400 cursor-not-allowed' : 'bg-indigo-600 hover:bg-indigo-700'
                    }`}
                >
                    {isUploading ? 'Procesando...' : (
                        <>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-5 h-5 mr-2"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M12 6V4m0 16v-2m6-9h2m-16 0H4m16.243 5.757l1.414 1.414m-16.486 0l1.414-1.414M16.243 8.243l1.414-1.414M7.343 15.657l-1.414 1.414"
                            />
                        </svg>
                        Procesar
                        </>
                    )}
                </button>
                </div>
            </div>
        </div>

        <div className="bg-white shadow-lg p-6  mx-4 mb-2">
            <h2 className="text-xl font-semibold mb-4">Escaner de Tickets</h2>

            Escaner de tickets impresos
            {alert3
            ?<Alert variant={claseAlert3} onClose={() => setAlert3(false)} dismissible fade show>
                <Alert.Heading>{tituloAlert3}</Alert.Heading>
                    <p>
                        {textoAlert3}
                     </p>
            </Alert>
            :''
            }  

            {/* Contenedor de los controles */}
            <div className="flex flex-col sm:flex-row gap-4">
                {/* Input de texto */}
                <div className="flex-1">
                <input
                    value={barcode} 
                    onChange={handleBarcode} 
                    ref={searchInput}
                    type="text"
                    className="w-full px-4 py-2 text-sm border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    placeholder="Ingrese código"
                />
                </div>

                {/* Botón Escanear con icono */}
                <div>
                <button
                    onClick={consumirTicket}
                    className="flex items-center px-4 py-2 bg-indigo-600 text-white rounded-lg shadow-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                >
                    {/* Icono de Escáner */}
                    <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5 mr-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    stroke-width="2"
                    >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M12 8v4m0 4v4m-6-4h12M4 12h16M6 6h12M6 6v12m12-12v12"
                    />
                    </svg>
                    Escanear
                </button>
                </div>
            </div>

        
        </div>

        <Modal show={show} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Consumir Ticket</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='row divAbsolute'>
                    <div className='col col-lg-12'>
                        {alert
                        ?<Alert variant={claseAlert} onClose={() => setAlert(false)} dismissible fade show>
                            <Alert.Heading>{tituloAlert}</Alert.Heading>
                                <p>
                                    {textoAlert}
                                </p>
                        </Alert>
                        :''
                        }
                    </div>
                </div>

                <div className="space-y-6">
                    {/* Rut Cliente */}
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 items-center">
                        <label className="font-semibold text-gray-700">Rut Cliente</label>
                        <div className="col-span-2">
                        <input
                            type="text"
                            value={rut}
                            disabled
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg text-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        />
                        </div>
                    </div>

                    {/* Rut Beneficiario */}
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 items-center">
                        <label className="font-semibold text-gray-700">Rut Beneficiario</label>
                        <div className="col-span-2">
                        <select
                            onChange={handleBeneficiario}
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg text-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        >
                            <option>Seleccion beneficiario</option>
                            {listBeneficiarios}
                        </select>
                        </div>
                    </div>

                    {/* Fecha Consumo */}
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 items-center">
                        <label className="font-semibold text-gray-700">Fecha Consumo</label>
                        <div className="col-span-2">
                        <input
                            type="date"
                            onChange={handleFecha}
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg text-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        />
                        </div>
                    </div>
                </div>

            </Modal.Body>
            <Modal.Footer>
            <button
                onClick={handleClose}
                className="bg-red-600 text-white px-6 py-2 rounded-lg shadow-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 transition duration-200"
                >
                Cerrar
            </button>

            <button
                onClick={createConsumoManual}
                className="bg-indigo-600 text-white px-6 py-2 rounded-lg shadow-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 transition duration-200"
                >
                Consumir
            </button>

            </Modal.Footer>
            <Modal.Footer className={visible}>
            <div>
                <h4>Debe completar todos los campos</h4>
            </div>
            </Modal.Footer>
        </Modal>                                                                                                                                                                                           
    </div>    
    )
}
export default Grillaboticket